import { useState, useContext, useEffect } from "react";
import { Row, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge } from "react-bootstrap";

import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
import moment from "moment";
import { useParams } from "react-router-dom";
import { UserContext } from "../../common";
import RoleForm from "./RoleForm";

import MessageModal from "../../components/MessageModal";

const Roles = (props) => {
  const { userData } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [roling, setRoling] = useState(false);
  const [roles, setRoles] = useState([]);
  const [mode, setMode] = useState(0);
  const [selectedRole, setSelectedRole] = useState(0);
  const [filter, setFilter] = useState({ start: 0, limit: 10 });
  const [message, setMessage] = useState(false);

  const fetchRoles = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchroles"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setRoles(_.get(res, "data.roles", []));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchRoles, []);

  const afterSave = (res) => {
    setMessage({
      type: res.success ? "info" : "error",
      message: _.isObject(res.message) ? Object.values(res.message).join(",") : res.message,
    });
    if (res.success) {
      setMode(0);
      setSelectedRole(false);
      fetchRoles();
    }
  };

  const toggleData = (e, d) => {
    if (window.confirm(`You are going to ${d.is_active === "1" ? "de" : ""}activate this role, continue?`)) {
      axios
        .post(Utils.apiUrl("users/togglerole"), `id=${d.id}`, Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setMessage({ type: "success", message: res.data.message });
            fetchRoles();
          }
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      e.preventDefault();
    }
  };

  const handleDelete = (e, d) => {
    if (window.confirm(`You are going to delete this role, continue?`)) {
      axios
        .delete(Utils.apiUrl(`users/deleterole/${d.id}`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setMessage({ type: "success", message: res.data.message });
            fetchRoles();
          }
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      e.preventDefault();
    }
  };

  if (!_.get(userData, "is_super_user", false)) {
    return (
      <>
        <h1 class="alert alert-danger p-5 mt-5">No access!</h1>
      </>
    );
  }

  return (
    <>
      <Row className="px-2 mt-2 mb-3">
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/users`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Users
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/roles`} className="w-100 btn btn-primary py-2 fw-bold">
            Manage Roles
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/helpmat`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Help Materials
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/userDocument`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Staff Documents
          </a>
        </Col>
      </Row>

      <div className="p-3 bg-white">
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">Fetching Roles</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}
        {!loading && (
          <>
            {mode !== 0 && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>{["", "Add", "Edit"][props.mode]} Role</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="secondary" onClick={() => setMode(0)}>
                      Back
                    </Button>
                  </Col>
                </Row>
                <RoleForm mode={mode} data={selectedRole} afterSave={afterSave} />
              </>
            )}

            {mode === 0 && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>Manage Roles</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="success" onClick={() => setMode(1)}>
                      Add +
                    </Button>
                  </Col>
                </Row>

                {roles.length === 0 && <div className="alert alert-info p-5 text-center">No Roles added yet!</div>}

                {roles.length > 0 && (
                  <Table striped={true}>
                    <thead>
                      <tr>
                        <th style={{ width: "40px" }}>Sl.</th>
                        <th>Role</th>
                        <th className="d-none d-sm-table-cell" style={{ width: "160px" }}>
                          Added On
                        </th>
                        <th style={{ width: "100px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roles.map((rl, idx) => (
                        <tr>
                          <td>{filter.start + idx + 1}</td>
                          <td>{rl.name}</td>
                          <td className="d-none d-sm-table-cell">{rl.created_at}</td>
                          <td>
                            <div className="d-flex">
                              <div className="form-check form-switch clickable" title={`Click to ${rl.is_active === "1" ? "Disable" : "Enable"}`}>
                                <input
                                  onClick={(e) => toggleData(e, rl)}
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  defaultChecked={rl.is_active == "1"}
                                />
                              </div>
                              <img
                                width="22"
                                src={`${process.env.PUBLIC_URL}/images/edit.png`}
                                className="p-1 me-2 clickable"
                                title="Edit Role"
                                onClick={() => {
                                  setSelectedRole(rl);
                                  setMode(2);
                                }}
                              />
                              {rl.hasUsers === "0" && (
                                <img
                                  width="20"
                                  src={`${process.env.PUBLIC_URL}/images/delete.png`}
                                  className="p-1 clickable"
                                  onClick={(e) => handleDelete(e, rl)}
                                  title="Delete Role"
                                />
                              )}
                              {rl.hasUsers !== "0" && (
                                <img width="20" src={`${process.env.PUBLIC_URL}/images/delete-d.png`} className="p-1" title="Role has users" />
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </>
            )}
          </>
        )}
      </div>

      {message && (
        <MessageModal
          type={message.type}
          message={message.message}
          onHide={() => {
            setMessage(false);
          }}
        />
      )}
    </>
  );
};

export default Roles;
